import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { dentalConsultationMessages } from '../../config';

import styles from './ScoreBar.module.scss';

type ScoreBarProps = {
  score: number;
};

const getScoreColor = (score: number) => {
  if (score >= 4) {
    return styles.scoreHigh;
  }
  if (score >= 3) {
    return styles.scoreMedium;
  }
  return styles.scoreLow;
};

export const ScoreBar: FC<ScoreBarProps> = ({ score }) => {
  const { formatMessage } = useIntl();
  const roundedScore = Math.round(score * 10) / 10;

  return (
    <div
      className={styles.scoreContainer}
      data-component="consultation-score-bar"
    >
      <div className={styles.scoreBar}>
        {[1, 2, 3, 4, 5].map((value) => (
          <div
            key={value}
            className={cn(
              styles.scoreSegment,
              value <= score && styles.scoreSegmentFilled,
              value <= score && getScoreColor(score),
            )}
          />
        ))}
      </div>
      <div className={cn('p3', styles.scoreText)}>
        {formatMessage(dentalConsultationMessages.scoreLabel, {
          score: roundedScore,
        })}
      </div>
    </div>
  );
};
